// opera环球的页面
import fangTHuanQiu from '@/components/huanQiuPage/fangTHuanQiu'
import indexHuanQiu from '@/components/huanQiuPage/indexHuanQiu'
import centerHuanQiu from '@/components/huanQiuPage/centerHuanQiu'
import bindBuildingHuanQiu from '@/components/huanQiuPage/bindBuildingHuanQiu'
import logRecordHuanQiu from '@/components/huanQiuPage/logRecordHuanQiu'
import logRecordRoom from "@/components/huanQiuPage/logRecordRoom";
import logRecordBindBuild from "@/components/huanQiuPage/logRecordBindBuild";
import versionDetailHuanQiu from "@/components/huanQiuPage/versionDetailHuanQiu";
import settingHuanQiu from "@/components/huanQiuPage/setting/settingHuanQiu";
import indexFangTDetail from "@/components/huanQiuPage/indexFangTDetail";
import huanqiuCenterInfo from "@/components/huanQiuPage/huanqiuCenterInfo";

const huanQiuRouter = [
  {
    path: '/opera/fangTHuanQiu',
    name: 'opera-fangTHuanQiu',
    component: fangTHuanQiu
  }, {
    path: '/opera/indexHuanQiu',
    name: 'opera-indexHuanQiu',
    component: indexHuanQiu
  }, {
    path: '/opera/centerHuanQiu',
    name: 'opera-centerHuanQiu',
    component: centerHuanQiu
  }, {
    path: '/opera/huanqiuCenterInfo',
    name: 'opera-huanqiuCenterInfo',
    component: huanqiuCenterInfo
  }, {
    path: '/opera/bindBuildingHuanQiu',
    name: 'opera-bindBuildingHuanQiu',
    component: bindBuildingHuanQiu
  },{
    path: '/opera/logRecordHuanQiu',
    name: 'opera-logRecordHuanQiu',
    component: logRecordHuanQiu
  },{
    path: '/opera/logRecordRoom',
    name: 'opera-logRecordRoom',
    component: logRecordRoom
  },{
    path: '/opera/logRecordBindBuild',
    name: 'opera-logRecordBindBuild',
    component: logRecordBindBuild
  },{
    path: '/opera/versionDetailHuanQiu',
    name: 'opera-versionDetailHuanQiu',
    component: versionDetailHuanQiu
  },{
    path: '/opera/settingHuanQiu',
    name: 'opera-settingHuanQiu',
    component: settingHuanQiu
  },{
    path: '/opera/indexFangTDetail',
    name: 'opera-indexFangTDetail',
    component: indexFangTDetail
  },
]

export default huanQiuRouter



// WEBPACK FOOTER //
// ./src/router/huanQiuRouter.js